import { useInView } from 'react-intersection-observer';
import styles from './aboutme.module.scss';
import { useEffect, useState } from 'react';

const AboutMe = ({ scrollRef }) => {
  const [firstRef, firstVew] = useInView();
  const [secondView, setSecondView] = useState(false);
  const [, thirdView] = useInView();
  const [lineRef, lineView] = useInView();
  const [asFade, setAsFade] = useState(false);
  const [, setToFade] = useState(false);

  useEffect(() => {
    if (secondView) {
      setTimeout(() => {
        setAsFade(true);
      }, 300);
      return () => {
        setAsFade(false);
      };
    }
  }, [secondView]);

  useEffect(() => {
    if (thirdView) {
      setTimeout(() => {
        setToFade(true);
      }, 300);
    }
    return () => {
      setToFade(false);
    };
  }, [thirdView]);

  useEffect(() => {
    if (firstVew) {
      setSecondView(true);
      return () => {
        setSecondView(false);
      };
    }
  }, [firstVew]);

  return (
    <div className={styles.container}>
      <section className={styles.contentSection}>
        <div
          className={`${styles.yLine} ${styles.scale} ${
            secondView ? styles.scaleLoad : ''
          }`}
        ></div>
        <div className={styles.contentWrapper}>
          <p
            className={`${styles.mainTitle} ${styles.slideUp} ${
              firstVew ? styles.slideUpLoad : ''
            }`}
          >
            About me
          </p>
          <div
            className={`${styles.asIs} ${styles.slideUp} ${
              secondView ? styles.slideUpLoad : ''
            }`}
            ref={firstRef}
          >
            <div className={styles.asIsList}>
              <ul className={`${styles.fade} ${asFade ? styles.fadeLoad : ''}`}>
                <li>
                  👩‍💻 IT 세미나에 참가해서 새로운 지식을 얻는 것을 좋아합니다.
                  <a href='https://sysoutctrlspace.tistory.com/category/Review'>
                    <div className={styles.listBtn}> 후기보기 👀 </div>
                  </a>
                </li>
                <li>
                  📚 현재 쉽게 시작하는 타입스크립트, 우아한 타입스크립트 책을
                  읽으며 타입스크립트를 공부하고 있습니다.
                </li>
                <li>
                  🏃🏻‍♀️ 코딩은 엉덩이로 한다! 러닝을 하며 꾸준히 체력 관리를 하고
                  있습니다.{' '}
                </li>
                <li>
                  👯‍♀️ 동료들과 지식을 나누며 함께 성장하는 것을 좋아합니다.
                </li>
                <li>🐢 지혜롭게 고통을 견디는 법을 알고있습니다.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section
        className={styles.designSection}
        ref={(el) => (scrollRef.current[2] = el)}
      >
        <div
          className={`${styles.xLine} ${styles.scale} ${
            lineView ? styles.scaleLoad : ''
          }`}
          ref={lineRef}
        ></div>
      </section>
    </div>
  );
};

export default AboutMe;
